// extracted by mini-css-extract-plugin
export default {"loader-container":"styles_loader-container__afrN6","loader":"styles_loader__mFi4t","spin":"styles_spin__e7kGU"};